import { createSlice } from "@reduxjs/toolkit";
import axios from "axios";

const initialState = {
  references: {
    data: [],
    currentPage: 0,
    numberOfPages: 0,
  },
  loading: false,
  error: null,
};

const slice = createSlice({
  name: "reference",
  initialState,
  reducers: {
    getReferenceSuccess: (state, { payload }) => {
      state.references = payload;
      state.loading = false;
    },
    startLoadingReference: (state) => {
      state.loading = true;
    },
    hasError: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
  },
});

export default slice.reducer;

export const getAllReferences = ({ accessToken, page }) => {

  const headers = {
    "Content-Type": "application/json",
    Authorization: accessToken,
  };
  return async (dispatch) => {
    try {
     
      dispatch(slice.actions.startLoadingReference());
      const res = await axios.get(
        `${process.env.REACT_APP_BACKEND_API}/get-all-references`,
        { headers }
      );
      dispatch(slice.actions.getReferenceSuccess(res.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error.message));
    }
  };
};


